import { render, staticRenderFns } from "./PpvOlderVisitsModal.vue?vue&type=template&id=41c0ba72&scoped=true"
import script from "./PpvOlderVisitsModal.vue?vue&type=script&lang=js"
export * from "./PpvOlderVisitsModal.vue?vue&type=script&lang=js"
import style0 from "./PpvOlderVisitsModal.vue?vue&type=style&index=0&id=41c0ba72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c0ba72",
  null
  
)

export default component.exports